import { useState } from "react";
import Navigation from "./components/Navigation";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import About from "./pages/About";
import Eligibility from "./pages/Eligibility";
import Apply from "./pages/Apply";
import Beneficiaries from "./pages/Beneficiaries";
import Contact from "./pages/Contact";

export default function MainApp() {
  const [currentPage, setCurrentPage] = useState("home");
  const [userData, setUserData] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("token");
    setUserData(null);
    setCurrentPage("home");
  };

  const handleLoginSuccess = (data) => {
    setUserData(data);
    setCurrentPage("dashboard");
  };

  const fullWidthPages = ["home","about","eligibility","contact"];
  const isFullWidth = fullWidthPages.includes(currentPage);

  const renderPage = () => {
    switch (currentPage) {
      case "home":          return <Home setCurrentPage={setCurrentPage}/>;
      case "login":         return <Login onSuccess={handleLoginSuccess} setCurrentPage={setCurrentPage}/>;
      case "dashboard":     return <Dashboard userData={userData} onLogout={handleLogout}/>;
      case "apply":         return <Apply setCurrentPage={setCurrentPage}/>;
      case "about":         return <About/>;
      case "eligibility":   return <Eligibility/>;
      case "beneficiaries": return <Beneficiaries setCurrentPage={setCurrentPage}/>;
      case "contact":       return <Contact/>;
      default:              return <Home setCurrentPage={setCurrentPage}/>;
    }
  };

  return (
    <div style={{ minHeight:"100vh", backgroundColor:"var(--bg-light)" }}>
      <Navigation currentPage={currentPage} setCurrentPage={setCurrentPage}/>
      <main style={{ maxWidth: isFullWidth ? "none" : "1200px", margin:"0 auto", padding: isFullWidth ? "0" : "0" }}>
        {renderPage()}
      </main>
    </div>
  );
}




